const index = () => import('./Index');

//2021年中小企业延链补链强链发展资金
export default {
  routes: [
    {
      path: '/smes/develop/v2022/index',
      name: 'smes_develop_v2022_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/develop/v2022/router.js